import React from 'react';
// Mui components
import { Button, Typography } from '@mui/material';

//import { useNavigate } from 'react-router-dom';

export default function PaginaPreLoginBienvenida() {
  // const navigate = useNavigate();

  //  const [error, setError] = useState();

  return (
    <>
      <Typography
        Typography
        variant="h1"
        sx={{
          fontSize: '48px !important',
          lineHeight: '50px !important',
          marginTop: '2vh'
        }}>
        Te damos la bienvenida
      </Typography>
      <Typography
        variant="h5"
        component="p"
        sx={{
          fontSize: '16px',
          color: '#202327'
        }}>
        Accedé para solicitar la conexión de tus agendas.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        sx={{
          height: '48px',
          position: 'relative',
          padding: '0.5rem 2rem',
          marginTop: '2vh',
          borderRadius: '2vh',
          width: '100%'
        }}
        href="/prestador/verifyUser">
        Iniciar sesión
      </Button>
      <Button
        href="https://prestadores.osde.com.ar/conecta-tus-agendas-con-osde"
        target="_blank"
        variant="text"
        color="primary"
        sx={{
          marginTop: '1.5vh',
          textDecoration: 'underline',
          textUnderlineOffset: '2px'
        }}>
        Más información
      </Button>
    </>
  );
}
